import { render } from "./AddExcelApoyo.vue?vue&type=template&id=2ab62557"
import script from "./AddExcelApoyo.vue?vue&type=script&lang=js"
export * from "./AddExcelApoyo.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\esteb\\Desktop\\PlantillaEsteban\\fronted-plantilla\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__